import React from "react";

export default function FooterBottom() {
  return (
    <footer className="bg-[#071325] text-gray-400">
      <div className="mx-auto max-w-7xl px-6 py-8">
        <div className="flex flex-col items-center justify-between gap-6 text-center md:flex-row md:text-left">
          {/* Logo */}
          <div className="text-3xl font-serif font-medium">
            <span className="text-[#C8A34D]">Y&B</span>{" "}
            <span className="text-white">Capital</span>
          </div>

          {/* Copyright */}
          <p className="text-sm text-gray-500">
            © 2025 Y&B Capital Pvt Ltd • All rights reserved
          </p>

          {/* Registration */}
          <p className="text-sm text-gray-500">
            CIN: [Registration Number] • SEBI Registered Investment Adviser
          </p>
        </div>
      </div>
    </footer>
  );
}
